<template>
	<div>
		<div class="second_box">
			<a href="#" v-for="(item,index) in yp_tabbar" @click="yq_tabbarFn(index)" :class="tabArrindex == index ? 'active' : ''">{{item}}</a>
		</div>
	</div>
</template>

<script>
	import  firstSecondTabbarValue from '../../firstSecondTabbar.js';//引入兄弟组建公共js
	export default {
		props: ['firstCateSwiperSendIndex04'],
		data () {
			return {
				tabArrindex: null,
				yp_tabbar: ["衍生言情","衍生纯爱"],
			}
		},
		created(){
			// 接收一级导航兄弟组建传值
			// firstSecondTabbarValue.$on('firstTabbarItemValue',(data)=>{
			// // console.log(data,'firstTabbarItemValue')
			// this.firstTabarrIndex = data;
			// this.tabArrindex = null;
			// })
		},
		watch: {
		  firstCateSwiperSendIndex04(value, oldvalue) {
		    // 接收 swiper组件传过来的索引，导航高亮
		    this.tabArrindex = value
		  }
		},
		methods:{
			yq_tabbarFn(data){
				console.log(data,'data')
				this.tabArrindex = data;
				this.$emit('firSecondCategroy04',this.tabArrindex)
			},
		}
	}
</script>

<style lang="less" scoped>
	.second_box {
		display: flex;
		justify-content: space-between;
		line-height: 70px;
		padding: 0 200px;
		background-color: #fff;
		// background-color: rgba(255,255,255,.5);
		border-bottom: 1px solid #f0f0f0;/*no*/
		a {
			font-size: 32px;
			/*px*/
		}
		.active {
			font-weight: bold;
			color: #ff4081;
		}
	}
</style>

